import { LOGIN_PAGE } from '@/config/appRoutes';
import { useAuth } from '@/hooks/useAuth';
import { LOGOUT_NAVIGATION_STATE } from '@/lib/redirectTo';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = useCallback(async (): Promise<void> => {
    // Navigate first so the protected route does not add a redirect_to param
    navigate(LOGIN_PAGE, { replace: true, state: LOGOUT_NAVIGATION_STATE });

    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', {
        error: error instanceof Error ? error.message : 'Unknown error',
        timestamp: new Date().toISOString(),
        userId: user?.id,
      });
    } finally {
      // Session is cleared, drop the logout marker so the next login can redirect
      navigate(LOGIN_PAGE, { replace: true });
    }
  }, [logout, navigate, user?.id]);

  return { handleLogout };
};
